import PropTypes from 'prop-types';
import { Grid, Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import OrientalImageText from '../../images/headerthank.svg';
import { COLOR4, RADIO_COLOR } from '../../constants';

const styledClasses = {
  header: {
    marginBottom: '15px',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    background: '#F8F8F8',
  },
  headerContainer: {
    background: '#FFFFFF',
    width: '100%',
    paddingTop: '30px',
    paddingBottom: '15px',
  },
  orientalText: {
    marginLeft: '40px',
    '@media (max-width:600px)': {
      marginLeft: '15px',
    },
  },
  button: {
    border: `1.6px solid ${RADIO_COLOR}`,
    borderRadius: '56px',
    opacity: 1,
    margin: '10px 0px 0px 37px',
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: 12,
    lineHeight: '16px',
    textAlign: 'center',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      margin: '10px 0px 0px 15px',
    },
  },
};

export default function Header({ disableMargin }) {
  const { t } = useTranslation();
  const handleBacktoAccount = () => {
    window.dispatchEvent(
      new CustomEvent('goto-account', {
        bubbles: true,
        composed: true,
      })
    );
  };
  return (
    <Grid container sx={styledClasses.header}>
      <Box sx={styledClasses.headerContainer}>
        <div>
          <Box
            component="img"
            src={OrientalImageText}
            alt="FDIC Insured"
            aria-label="FDIC Insured"
            sx={{
              ...styledClasses.orientalText,
              ...(disableMargin && {
                marginLeft: 0,
                '@media (max-width:600px)': {
                  marginLeft: 0,
                },
              }),
            }}
          />
        </div>
        <Button
          variant="outlined"
          onClick={handleBacktoAccount}
          startIcon={<ArrowBackIcon />}
          sx={{
            ...styledClasses.button,
            ...(disableMargin && {
              margin: '10px 0px 0px 0px',
              '@media (max-width: 600px)': {
                margin: '10px 0px 0px 0px',
              },
            }),
          }}
        >
          {' '}
          {t('Back to my accounts', {
            defaultValue: 'Back to my accounts',
          })}{' '}
        </Button>
      </Box>
    </Grid>
  );
}

Header.propTypes = {
  disableMargin: PropTypes.bool,
};

Header.defaultProps = {
  disableMargin: false,
};
